import { render, staticRenderFns } from "./TambahKalendar.vue?vue&type=template&id=bfe1cb2a&scoped=true"
import script from "./TambahKalendar.vue?vue&type=script&lang=js"
export * from "./TambahKalendar.vue?vue&type=script&lang=js"
import style0 from "./TambahKalendar.vue?vue&type=style&index=0&id=bfe1cb2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe1cb2a",
  null
  
)

export default component.exports